/* Detailing1 Paket D 2026-09: Collection-Leiste – Umschalter Varianten/Produkte (?view=…) und Suche innerhalb der Collection.
   Die Suche filtert die gerenderten Karten (data-d1-search) und lädt vorher alle weiteren Seiten über custom-pagination nach. */
(function () {
  if (customElements.get('d1-collection-search')) return;

  // facet-filters ersetzt beim Filtern den kompletten Inhalt von #facets — damit verschwände die Eingabe.
  // Deshalb liegt der Suchtext außerhalb des Elements und wird nach dem Neuaufbau wiederhergestellt.
  let letzterSuchtext = '';

  class D1CollectionSearch extends HTMLElement {
    connectedCallback() {
      if (this.listeners) this.listeners.abort();
      this.listeners = new AbortController();
      const listenerOptions = { signal: this.listeners.signal };
      this.input = this.querySelector('input');
      this.clearBtn = this.querySelector('.js-d1-csearch-clear');
      if (!this.input) return;
      this.query = '';
      if (letzterSuchtext && !this.input.value) {
        this.input.value = letzterSuchtext;
        if (this.clearBtn) this.clearBtn.hidden = false;
        this.timer = setTimeout(() => this.apply(), 60);
      }
      this.input.addEventListener('input', () => {
        this.applyId = (this.applyId || 0) + 1;
        letzterSuchtext = this.input.value;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.apply(), 250);
      }, listenerOptions);
      this.input.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter') evt.preventDefault();
        if (evt.key === 'Escape') { this.input.value = ''; letzterSuchtext = ''; this.apply(); }
      }, listenerOptions);
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => { this.input.value = ''; letzterSuchtext = ''; this.apply(); this.input.focus(); }, listenerOptions);
      }
      document.addEventListener('on:facet-filters:updated', () => { if (this.query) this.apply(); }, listenerOptions);
      document.addEventListener('on:d1-mode:updated', () => { if (this.query) this.apply(); }, listenerOptions);
    }

    disconnectedCallback() {
      if (this.listeners) this.listeners.abort();
      clearTimeout(this.timer);
      this.applyId = (this.applyId || 0) + 1;
      this.query = '';
    }

    static norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss');
    }

    get results() { return document.getElementById('filter-results'); }
    get grid() { const r = this.results; return r ? r.querySelector('ul.grid') : null; }
    get pagination() { return document.querySelector('custom-pagination'); }

    async apply() {
      if (!this.isConnected) return;
      clearTimeout(this.timer);
      this.applyId = (this.applyId || 0) + 1;
      const applyId = this.applyId;
      const q = D1CollectionSearch.norm(this.input.value).trim();
      this.query = q;
      if (this.clearBtn) this.clearBtn.hidden = !q;
      if (!q) { this.reset(); return; }
      await this.loadAll(q, applyId);
      if (!this.isConnected || this.query !== q || this.applyId !== applyId) return;
      this.filter(q);
    }

    async loadAll(q, applyId) {
      const cp = this.pagination;
      if (!cp || typeof cp.loadMore !== 'function') return;
      let guard = 0;
      while (this.isConnected && cp.isConnected && this.applyId === applyId && this.query === q && guard < 30 && cp.querySelector('.js-pagination[data-is-more-results]') && cp.dataset.pauseInfiniteScroll !== 'true') {
        guard += 1;
        this.setStatus(this.dataset.tLoading, true);
        if (cp.isFetching) { await new Promise((r) => { setTimeout(r, 150); }); continue; }
        const before = cp.querySelectorAll('.js-pagination-result').length;
        await cp.loadMore();
        if (cp.querySelectorAll('.js-pagination-result').length === before && cp.querySelector('.js-pagination[data-is-more-results]')) break;
      }
    }

    filter(q) {
      const grid = this.grid;
      if (!grid) return;
      const terms = q.split(/\s+/).filter(Boolean);
      let hits = 0;
      grid.querySelectorAll(':scope > li').forEach((li) => {
        const card = li.querySelector('product-card');
        const hay = D1CollectionSearch.norm(li.dataset.d1Search !== undefined ? li.dataset.d1Search : li.textContent);
        const ok = !!card && terms.every((t) => hay.includes(t));
        li.classList.toggle('d1-csearch-hide', !ok);
        if (ok) hits += 1;
      });
      // Schnellbestell-Ansicht: Zeilen (Titel, SKU, EAN) ebenfalls filtern
      document.querySelectorAll('#d1-cqo [data-qo-rows] tr[data-vid]').forEach((tr) => {
        const hay = D1CollectionSearch.norm(`${tr.textContent} ${tr.dataset.sku || ''} ${tr.dataset.ean || ''}`);
        const ok = terms.every((t) => hay.includes(t));
        tr.classList.toggle('d1-csearch-hide', !ok);
        if (ok) hits += 1;
      });
      const cp = this.pagination;
      if (cp) { const p = cp.querySelector('.js-pagination'); if (p) p.classList.add('d1-csearch-hide'); }
      if (hits) {
        this.setStatus((this.dataset.tResults || '__n__').replace('__n__', hits));
      } else {
        const url = `${this.dataset.searchUrl || '/search'}?q=${encodeURIComponent(this.input.value.trim())}&type=product`;
        this.setStatus(`${this.dataset.tNone} <a href="${url}">${this.dataset.tAll}</a>`, false, true);
      }
      this.classList.add('is-active');
    }

    reset() {
      const grid = this.grid;
      if (grid) grid.querySelectorAll(':scope > li.d1-csearch-hide').forEach((li) => li.classList.remove('d1-csearch-hide'));
      document.querySelectorAll('#d1-cqo tr.d1-csearch-hide').forEach((tr) => tr.classList.remove('d1-csearch-hide'));
      const cp = this.pagination;
      if (cp) { const p = cp.querySelector('.js-pagination'); if (p) p.classList.remove('d1-csearch-hide'); }
      this.setStatus('');
      this.classList.remove('is-active');
    }

    setStatus(text, loading, html) {
      const results = this.results;
      if (!results) return;
      let el = results.querySelector('.d1-csearch-status');
      if (!text) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'd1-csearch-status';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        results.prepend(el);
      }
      el.classList.toggle('is-loading', !!loading);
      if (html) el.innerHTML = text; else el.textContent = text;
    }
  }
  customElements.define('d1-collection-search', D1CollectionSearch);

  // Grid-Dichte (gröber / feiner) neben „Ansicht als“ – gemerkt wie die Listenansicht (theme.storageUtil)
  const initDensity = () => {
    const layoutBox = document.querySelector('.products-toolbar__layout');
    const grid = document.querySelector('.main-products-grid');
    const radios = layoutBox ? Array.from(layoutBox.querySelectorAll('.js-d1-density')) : [];
    if (!layoutBox || !grid || radios.length === 0) return;
    const gridOpt = document.getElementById('grid-layout-opt');
    const listOpt = document.getElementById('list-layout-opt');
    // Nur für die laufende Sitzung merken (sessionStorage): jeder neue Besuch startet im Standard-Grid.
    // Alte dauerhafte Werte aus der ersten Fassung (localStorage) entfernen.
    try { localStorage.removeItem('cc-d1-grid-density'); } catch (e) { /* kein Storage */ }
    const store = (v) => { try { theme.storageUtil.set('d1-grid-density', v, true); } catch (e) { /* kein Storage */ } };
    const load = () => { try { return theme.storageUtil.get('d1-grid-density', false, true); } catch (e) { return null; } };
    const apply = (value, persist) => {
      const v = value === 'coarse' || value === 'fine' ? value : 'default';
      grid.dataset.d1Density = v;
      radios.forEach((r) => { r.checked = r.value === v; });
      layoutBox.classList.toggle('d1-density-active', v !== 'default');
      if (persist) store(v);
    };
    radios.forEach((r) => {
      r.addEventListener('change', (evt) => {
        evt.stopPropagation(); // nicht in den Layout-Handler des Themes (products-toolbar) bubbeln
        if (gridOpt && !gridOpt.checked) gridOpt.click();
        apply(r.value, true);
      });
    });
    // click statt change: greift auch, wenn das normale Grid schon aktiv ist
    if (gridOpt) gridOpt.addEventListener('click', () => apply('default', true));
    if (listOpt) {
      listOpt.addEventListener('change', () => {
        radios.forEach((r) => { r.checked = false; });
        layoutBox.classList.remove('d1-density-active');
      });
    }
    const stored = load();
    if (stored && stored !== 'default' && grid.dataset.layout !== 'list') apply(stored, false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDensity);
  else initDensity();

  // Schnellbestell-Ansicht (Paket D3): dritte Ansicht neben Liste/Grid. Zeilen kommen per Section-Rendering
  // (sections/d1-collection-quick-order.liquid) mit Filtern/Sortierung der aktuellen URL; Mengen + Warenkorb
  // übernimmt <d1-quick-order> aus assets/d1-quick-order.js (B2B Quick Order).
  const initQuick = () => {
    const radio = document.getElementById('quick-layout-opt');
    const grid = document.querySelector('.main-products-grid');
    if (!radio || !grid) return;
    const layoutBox = radio.closest('.products-toolbar__layout');
    const box = () => document.getElementById('d1-cqo');
    let loading = false;
    const status = (text) => { const el = box(); const s = el && el.querySelector('[data-cqo-status]'); if (s) s.textContent = text || ''; };
    const load = async (url) => {
      const el = box();
      if (!el || loading) return;
      loading = true;
      const more = el.querySelector('[data-cqo-more]');
      if (more) more.disabled = true;
      status(el.dataset.tLoading);
      try {
        const u = new URL(url || window.location.href, window.location.origin);
        u.searchParams.set('section_id', el.dataset.section);
        const res = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error(String(res.status));
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const wrap = doc.querySelector('.d1-cqo-rows');
        const tbody = el.querySelector('[data-qo-rows]');
        if (!wrap || !tbody) throw new Error('rows missing');
        wrap.querySelectorAll('tbody > tr').forEach((tr) => tbody.appendChild(document.importNode(tr, true)));
        const next = wrap.dataset.next || '';
        if (more) { more.hidden = !next; more.dataset.next = next; more.disabled = false; }
        const pages = parseInt(wrap.dataset.pages, 10) || 1;
        const products = (el.dataset.tProducts || '__n__').replace('__n__', wrap.dataset.count || '');
        status(pages > 1 ? `${products} · ${wrap.dataset.page}/${pages}` : products);
        if (typeof el.applyCart === 'function') el.applyCart(); else if (typeof el.recalc === 'function') el.recalc();
      } catch (e) {
        status(el.dataset.tError);
        if (more) more.disabled = false;
      } finally {
        loading = false;
      }
    };
    const reset = () => { const el = box(); const tbody = el && el.querySelector('[data-qo-rows]'); if (tbody) tbody.innerHTML = ''; };
    const textBtn = (on) => document.querySelectorAll('.js-d1-quick-textbtn').forEach((b) => {
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // Text-Button ist ein <label> — Klick selbst steuern, damit ein zweiter Klick die Ansicht wieder schließt
    let vorherigeAnsicht = 'grid';
    document.addEventListener('click', (evt) => {
      const btn = evt.target.closest('.js-d1-quick-textbtn');
      if (!btn) return;
      evt.preventDefault();
      if (radio.checked) {
        const zurueck = document.getElementById(vorherigeAnsicht === 'list' ? 'list-layout-opt' : 'grid-layout-opt');
        if (zurueck) zurueck.click();
      } else {
        const liste = document.getElementById('list-layout-opt');
        vorherigeAnsicht = liste && liste.checked ? 'list' : 'grid';
        radio.click();
      }
    }, true);
    const activate = () => {
      const el = box();
      if (!el) return;
      el.hidden = false;
      textBtn(true);
      if (layoutBox) {
        layoutBox.classList.remove('d1-density-active');
        layoutBox.querySelectorAll('.js-d1-density').forEach((r) => { r.checked = false; });
      }
      if (!el.querySelector('[data-qo-rows] tr')) load();
    };
    const deactivate = () => { const el = box(); if (el) el.hidden = true; textBtn(false); };
    radio.addEventListener('change', () => { if (radio.checked) activate(); });
    document.addEventListener('change', (evt) => {
      if (evt.target.matches && evt.target.matches('#list-layout-opt, #grid-layout-opt') && evt.target.checked) deactivate();
    });
    document.addEventListener('click', (evt) => {
      const more = evt.target.closest && evt.target.closest('[data-cqo-more]');
      if (more) { evt.preventDefault(); load(more.dataset.next); }
    });
    document.addEventListener('on:facet-filters:updated', () => { if (radio.checked) { reset(); activate(); } });
    let stored = null;
    try { stored = theme.storageUtil.get('products-layout'); } catch (e) { /* kein Storage */ }
    if (stored === 'quick' && !radio.checked) radio.click();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initQuick);
  else initQuick();

  // ---------------------------------------------------------------------------------------------------------------
  // Paket D5: Kartenmodus (Varianten | Produkte) ohne zweites Template.
  // Die Seite kommt im Standard der Collection (Metafeld). Die andere Ansicht liefert eine Abruf-Section
  // (sections/d1-cards-produkte / d1-cards-varianten) per Section-Rendering-API — nur das Raster wird getauscht,
  // Filter/Sortierung bleiben in der URL, Nachladen läuft über custom-pagination mit umgestellter section-id.
  // Schnell: Antwort enthält nur Karten + Paginierung, Vorabruf beim Zeigen auf den Button, Ergebnis-Cache je URL,
  // gemerkter Modus (Sitzung) wird ohne Aufblitzen des Standards angewendet (Klasse d1-mode-pending vom Inline-Script).
  // Vorrang: Hat die Collection einen Modus per Metafeld hinterlegt (data-d1-mode-fixed), gilt beim Laden immer dieser;
  // die Sitzungswahl des Kunden greift nur bei Collections ohne Vorgabe. Inline-Promos bleiben beim Tausch stehen.
  const initMode = () => {
    const cp = document.querySelector('custom-pagination.main-products-grid');
    if (!cp || !cp.dataset.d1Mode || !document.querySelector('.js-d1-mode')) return;
    // Die Bedienelemente stehen an mehreren Stellen (Leiste, Filterbereich) und der Filterbereich wird beim Filtern
    // neu gerendert — deshalb jedes Mal frisch einsammeln und den Klick am document abfangen (Delegation).
    const alleBtns = () => Array.from(document.querySelectorAll('.js-d1-mode'));
    const KEY = 'cc-d1-card-mode';
    const SECTIONS = { product: 'd1-cards-produkte', variants: 'd1-cards-varianten' };
    const serverMode = cp.dataset.d1Mode;
    const fixed = cp.dataset.d1ModeFixed === 'true';
    const mainSection = cp.dataset.sectionId;
    const cache = new Map();
    let current = serverMode;
    let busy = false;

    const grid = () => document.querySelector('#filter-results ul.grid');
    const isPromo = (li) => /(^|\s)promo-item--/.test(li.className);
    const setActive = (mode) => alleBtns().forEach((b) => {
      const on = b.dataset.mode === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const fetchUrl = (mode) => {
      const u = new URL(window.location.href);
      u.hash = '';
      u.searchParams.delete('page');
      u.searchParams.set('section_id', mode === serverMode ? mainSection : SECTIONS[mode]);
      return u.toString();
    };
    const load = (mode) => {
      const url = fetchUrl(mode);
      if (cache.has(url)) return cache.get(url);
      const p = fetch(url, { headers: { Accept: 'text/html' } }).then((r) => {
        if (!r.ok) throw new Error(`Kartenmodus ${mode}: HTTP ${r.status}`);
        return r.text();
      });
      cache.set(url, p);
      p.catch(() => cache.delete(url));
      return p;
    };
    const apply = (html, mode) => {
      const g = grid();
      if (!g) return false;
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;
      const fresh = Array.from(tmpl.content.querySelectorAll('li.js-pagination-result'));
      if (!fresh.length && !tmpl.content.querySelector('ul.grid, ul[data-d1-cards]')) return false;
      const old = Array.from(g.querySelectorAll(':scope > li.js-pagination-result'));
      // Inline-Promos gehören zur Hauptsektion und fehlen in der Abruf-Antwort: aus dem aktuellen Raster übernehmen,
      // an derselben Stelle (Index) wieder einsetzen. Liefert die Antwort selbst Promos (Hauptsektion), gelten diese.
      const keep = fresh.some(isPromo) ? [] : old.filter(isPromo).map((li) => ({ li, idx: old.indexOf(li) }));
      old.forEach((li) => li.remove());
      const items = fresh.filter((li) => !keep.length || !isPromo(li));
      keep.forEach(({ li, idx }) => items.splice(Math.min(idx, items.length), 0, li));
      g.prepend(...items);
      const newPag = tmpl.content.querySelector('.js-pagination');
      const oldPag = cp.querySelector('.js-pagination');
      if (oldPag && newPag) oldPag.replaceWith(newPag);
      else if (oldPag) oldPag.remove();
      else if (newPag) g.after(newPag);
      cp.dataset.sectionId = mode === serverMode ? mainSection : SECTIONS[mode];
      if (typeof cp.reload === 'function') cp.reload();
      if (typeof window.initLazyImages === 'function') window.initLazyImages();
      return true;
    };
    const switchTo = async (mode) => {
      if (busy || !SECTIONS[mode]) return;
      busy = true;
      const g = grid();
      if (g) g.classList.add('d1-mode-loading');
      setActive(mode);
      try {
        const html = await load(mode);
        if (!apply(html, mode)) throw new Error('Kartenmodus: keine Karten in der Antwort');
        current = mode;
        try { sessionStorage.setItem(KEY, mode); } catch (e) { /* privat/gesperrt */ }
        document.dispatchEvent(new CustomEvent('on:d1-mode:updated', { detail: { mode } }));
      } catch (e) {
        setActive(current);
        console.warn(e); // eslint-disable-line
      } finally {
        const g2 = grid();
        if (g2) g2.classList.remove('d1-mode-loading');
        document.documentElement.classList.remove('d1-mode-pending');
        busy = false;
      }
    };

    document.addEventListener('click', (evt) => {
      const b = evt.target.closest('.js-d1-mode');
      if (!b || !document.contains(b)) return;
      evt.preventDefault();
      if (b.dataset.mode !== current) switchTo(b.dataset.mode);
    });
    // Vorabruf: beim Zeigen/Fokussieren ist die Antwort meist schon da, wenn geklickt wird
    const prefetch = (evt) => {
      const b = evt.target.closest && evt.target.closest('.js-d1-mode');
      if (b && b.dataset.mode !== current) load(b.dataset.mode).catch(() => {});
    };
    document.addEventListener('mouseover', prefetch, { passive: true });
    document.addEventListener('focusin', prefetch);
    document.addEventListener('touchstart', prefetch, { passive: true });

    // Filterwechsel rendert den Standard neu (facet-filters ersetzt #filter-results) -> gewählten Modus wieder anwenden
    document.addEventListener('on:facet-filters:updated', () => {
      setActive(current); // der Filterbereich wurde neu gerendert und kommt im Server-Zustand
      if (current !== serverMode) switchTo(current);
    });

    // Start: Metafeld-Vorgabe der Collection schlägt die Sitzungswahl; ohne Vorgabe gilt die Sitzung
    let wanted = serverMode;
    if (!fixed) {
      try { wanted = sessionStorage.getItem(KEY) || serverMode; } catch (e) { /* noop */ }
    }
    if (wanted !== serverMode && SECTIONS[wanted]) switchTo(wanted);
    else { setActive(serverMode); document.documentElement.classList.remove('d1-mode-pending'); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMode);
  else initMode();

  // ---------------------------------------------------------------------------------------------------------------
  // Paket D8: Collection-Beschreibung mobil einklappen. Der Button erscheint nur, wenn der Text wirklich länger ist
  // als die Klammerung — sonst bliebe ein „Mehr lesen" ohne Funktion stehen.
  const initMore = () => {
    const boxes = Array.from(document.querySelectorAll('.js-d1-more'));
    if (!boxes.length) return;
    const mq = window.matchMedia('(max-width: 768.98px)');
    const messen = () => boxes.forEach((box) => {
      const body = box.querySelector('.d1-more__body');
      const btn = box.querySelector('.js-d1-more-btn');
      if (!body || !btn) return;
      if (!mq.matches) { box.classList.remove('d1-more--clamped'); box.removeAttribute('data-open'); btn.hidden = true; return; }
      box.classList.add('d1-more--clamped'); // serverseitig bereits gesetzt — kein Nachrutschen beim Laden
      const offen = box.hasAttribute('data-open');
      if (offen) { btn.hidden = false; return; }
      const zuLang = body.scrollHeight - body.clientHeight > 4;
      btn.hidden = !zuLang;
      if (!zuLang) box.classList.remove('d1-more--clamped');
    });
    boxes.forEach((box) => {
      const btn = box.querySelector('.js-d1-more-btn');
      if (!btn || btn.dataset.d1Bound) return;
      btn.dataset.d1Bound = '1';
      btn.addEventListener('click', () => {
        const offen = box.toggleAttribute('data-open');
        btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
        btn.textContent = offen ? (btn.dataset.less || btn.textContent) : (btn.dataset.more || btn.textContent);
        if (!offen) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
    messen();
    if (mq.addEventListener) mq.addEventListener('change', messen);
    let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(messen, 150); }, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMore);
  else initMore();

  // ---------------------------------------------------------------------------------------------------------------
  // Paket D17: „Ansicht als" und „Schnellbestellung" stehen zusätzlich unten im Filter. Sie bedienen dieselben
  // Schalter wie die Leiste (Radios in products-toolbar) — so bleibt eine einzige Quelle für den Zustand.
  const initFilterControls = () => {
    const ziel = { list: 'list-layout-opt', grid: 'grid-layout-opt', coarse: 'd1-density-coarse', fine: 'd1-density-fine' };
    const spiegeln = () => {
      const dichte = document.querySelector('.js-d1-density:checked');
      const layout = document.querySelector('input[name="products-layout"]:checked');
      let aktiv = layout && layout.value === 'list' ? 'list' : 'grid';
      if (layout && layout.value === 'quick') aktiv = 'quick';
      if (aktiv === 'grid' && dichte) aktiv = dichte.value;
      document.querySelectorAll('.js-d1-flayout').forEach((b) => b.classList.toggle('is-active', b.dataset.layout === aktiv));
      document.querySelectorAll('.js-d1-fquick').forEach((b) => b.classList.toggle('is-active', aktiv === 'quick'));
    };
    document.addEventListener('click', (evt) => {
      const l = evt.target.closest('.js-d1-flayout');
      if (l) {
        if (l.dataset.layout === 'quick') {
          const tb = document.querySelector('.js-d1-quick-textbtn');
          if (tb) tb.click();
        } else {
          const el = document.getElementById(ziel[l.dataset.layout]);
          if (el) el.click();
        }
        setTimeout(spiegeln, 60);
        return;
      }
      const q = evt.target.closest('.js-d1-fquick');
      if (q) {
        const btn = document.querySelector('.js-d1-quick-textbtn');
        if (btn) btn.click();
        setTimeout(spiegeln, 60);
      }
    });
    document.addEventListener('change', (evt) => {
      if (evt.target.matches && evt.target.matches('input[name="products-layout"], .js-d1-density')) spiegeln();
    });
    document.addEventListener('on:facet-filters:updated', () => setTimeout(spiegeln, 60));
    spiegeln();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFilterControls);
  else initFilterControls();
})();
